export const ListShimmer = () => {
  return (
    <div>
      {Array.from({ length: 10 }).map((_, idx) => (
        <div
          key={idx}
          className="flex items-center p-4 border border-gray-200 rounded-lg shadow-md bg-white animate-pulse"
        >
          {/* Avatar */}
          <div className="w-12 h-12 bg-gray-200 rounded-full"></div>

          {/* Text Details */}
          <div className="ml-4 flex-grow space-y-2">
            <div className="h-4 bg-gray-200 rounded w-1/2"></div>
            <div className="h-4 bg-gray-200 rounded w-3/4"></div>
          </div>

          {/* Arrow Icon */}
          <div className="w-6 h-6 bg-gray-200 rounded-full"></div>
        </div>
      ))}
    </div>
  );
};
